import React from 'react';
import PropTypes from 'prop-types';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';

import {LETTER_COMBINATION_GROUP_SUBTITLES} from '../data/words';

const WordFilterMenu = (props) => {
  return (
    <Menu
      elevation={0}
      open={props.open}
      anchorEl={props.anchorEl}
      getContentAnchorEl={null}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
      onClose={props.handleRequestClose}
      keepMounted
    >
      {Object.entries(LETTER_COMBINATION_GROUP_SUBTITLES).map(([key, value]) => (
        <MenuItem key={key} onClick={() => props.handleClickFilterWordPattern(key)}>
          {value}
        </MenuItem>
      ))}
    </Menu>
  );
};

WordFilterMenu.propTypes = {
  open: PropTypes.bool.isRequired,
  anchorEl: PropTypes.object,
  handleRequestClose: PropTypes.func.isRequired,
  handleClickFilterWordPattern: PropTypes.func.isRequired,
};

export default WordFilterMenu;
